
import React from 'react';
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Game } from "@/types/game";
import { GameTableRow } from "./GameTableRow";
import { TableEmptyState } from "./TableEmptyState";

interface GamesTableProps {
  games: Game[];
  onEdit: (game: Game) => void;
  onDelete: (id: string) => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
}

export const GamesTable: React.FC<GamesTableProps> = ({
  games,
  onEdit,
  onDelete,
  searchTerm,
  setSearchTerm
}) => {
  return (
    <Table>
      <TableCaption>Lista de jogos cadastrados</TableCaption>
      <TableHeader>
        <TableRow className="hover:bg-[#1E293B] border-[#222A35]">
          <TableHead className="text-[#00B6F0] font-medium">Nome</TableHead>
          <TableHead className="text-[#00B6F0] font-medium">Imagem</TableHead>
          <TableHead className="text-[#00B6F0] font-medium">Data de Criação</TableHead>
          <TableHead className="text-[#00B6F0] font-medium text-right">Ações</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {games.length === 0 ? (
          <TableRow>
            <TableCell colSpan={4} className="text-center">
              <TableEmptyState searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
            </TableCell>
          </TableRow>
        ) : (
          games.map((game) => (
            <GameTableRow 
              key={game.id} 
              game={game} 
              onEdit={onEdit} 
              onDelete={onDelete} 
            />
          ))
        )}
      </TableBody>
    </Table>
  );
};
